var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{attrs:{"to":{ name: 'home' }}},[_c('img',{attrs:{"src":"/logo-home.png","width":_vm.imgWidth}})])}
var staticRenderFns = []

export { render, staticRenderFns }